import React from 'react';
import { useTranslation } from 'react-i18next';

export type TimeframeOption = 'all' | 'today' | '7days';

interface TransactionFiltersProps {
  timeframe: TimeframeOption;
  onTimeframeChange: (timeframe: TimeframeOption) => void;
  onRefresh: () => void;
  isRefreshing: boolean;
}

/**
 * A reusable component for transaction filter controls
 */
const TransactionFilters: React.FC<TransactionFiltersProps> = ({
  timeframe,
  onTimeframeChange,
  onRefresh,
  isRefreshing
}) => {
  const { t } = useTranslation();

  return (
    <div className="border-bottom pb-3 mb-4">
      <div className="row align-items-center">
        <div className="col-md-6">
          <h5 className="mb-md-0 d-flex align-items-center">
            {t('history.filterTransactions', 'Filter Transactions')}
            <button 
              className="btn btn-sm btn-outline-primary ms-3"
              onClick={onRefresh}
              disabled={isRefreshing}
            >
              {isRefreshing ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {t('common.refreshing', 'Refreshing...')}
                </>
              ) : (
                <>
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  {t('common.refresh', 'Refresh')}
                </>
              )}
            </button>
          </h5>
        </div>
        <div className="col-md-6">
          <div className="btn-group w-100">
            <button 
              className={`btn ${timeframe === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => onTimeframeChange('all')}
            >
              {t('history.allTime', 'All Time')}
            </button>
            <button 
              className={`btn ${timeframe === 'today' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => onTimeframeChange('today')}
            >
              {t('history.today', 'Today')}
            </button>
            <button 
              className={`btn ${timeframe === '7days' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => onTimeframeChange('7days')}
            >
              {t('history.last7Days', 'Last 7 Days')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionFilters; 